function escape(value: any): string {
    // Converte o valor para string, tratando null e undefined
    const str = value == null ? '' : String(value)
    const escaped = str.replace(/"/g, '""')

    return '"' + escaped + '"'
}

export function toCSV(list: object[]): string {
    if (list.length === 0) {
        return ''
    }

    let csv = Object.keys(list[0]).map(escape).join(',') + '\n'

    csv += list.map((row: object) => {
        return Object.values(row).map(escape).join(',')
    }).join('\n')

    return csv
}
